module.exports = __webpack_public_path__ + "static/img/40008 (2).3570fda.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40008 (2).webp
// module id = Mh6o
// module chunks = 14